export default "__VITE_ASSET__pLsK2xvK__"